import { handleError } from "../../../util/errors";
import apiBase from "../../api";
import {
  VSDC_FAILED_REQUESTS,
  VSDC_CLEAR_FAILED_REQUESTS,
  VIRTUAL_POS_TEST_DEVICES,
  VIRTUAL_POS_SUBMIT_INVOICE,
} from "../../urls";

class VsdcFailedRequestsService {
  getFailedRequests = async (limit = 100) => {
    try {
      const response = await apiBase.get(VSDC_FAILED_REQUESTS(limit));
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  clearFailedRequests = async () => {
    try {
      const response = await apiBase.delete(VSDC_CLEAR_FAILED_REQUESTS);
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  getTestDevices = async () => {
    try {
      const response = await apiBase.get(VIRTUAL_POS_TEST_DEVICES);
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  submitTestInvoice = async (invoiceData) => {
    try {
      const response = await apiBase.post(VIRTUAL_POS_SUBMIT_INVOICE, invoiceData);
      return response.data;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };
}

export default new VsdcFailedRequestsService();

